define [], () ->
  ($scope, $state, Flash, $stateParams, RENTAPPLICATION_API_URL, applicationTemplate, $cacheFactory, RentappService, INFO_PAGE_SLUGS) ->
    require('./../../../app.scss')
    require('./customize.scss')
    
    $scope.url = "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/"
    if applicationTemplate
      $scope.id = applicationTemplate.id
      if !applicationTemplate.can_edit
        $state.go "root.home.403"
    else
      RentappService.getMe().then (user) ->
        if !user.landlord
          $state.go "root.home.403"
      $scope.id = "default"

    $scope.onSave = (response) ->
      $scope.$apply ->
        $cacheFactory.get("$http").removeAll()

        if response.slug
          newApplicationTemplate = response
          if not applicationTemplate or newApplicationTemplate.slug != applicationTemplate.slug
              $state.transitionTo $state.current.name, {application_template_slug: response.slug}, { notify: false }



// WEBPACK FOOTER //
// ./components/applications/customize/customize.coffee